export interface MauticCampaignEvent {
   mt_event: string
   page_title: string
   pageurl: string
   tags:
      | "interest_news"
      | "interest_chomp_show"
      | "interest_pulse"
      | "interest_resource"
      | "Business_Growth"
      | "email_Verified"
      | "Sign_up"
      | "Pending_Verification"
      | "interest_topics"
      | "interest_video"
      | "interest_templates"
      | "interest_calculator"
      | "intent_contact"
      | "downloaded_template"
      | "downloaded_library"
      | "used_calculator"
      | "downloaded_benefit_resource"
      | "claimed_masterclass"
      | "job_subscription_claimed"
      | "requested_chomp_show"
   email?: string
}

export const MAUTIC_CAMPAIGNS = {
   signUp: {
      mt_event: "Sign Up",
      page_title: "Sign Up",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/news`,
      tags: "Sign_up",
   },
   interestTopics: {
      mt_event: "Topic for Users",
      page_title: " Topic for Users",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/news`,
      tags: "interest_topics",
   },
   shows: {
      mt_event: "Watch video Content",
      page_title: "Watch video Content",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/shows`,
      tags: "interest_video",
   },
   newsDigest: {
      mt_event: "News Read",
      page_title: "News Read",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/news`,
      tags: "interest_news",
   },
   chompShow: {
      mt_event: "Chomp Shows",
      page_title: "Chomp Shows",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/shows/Chomp%20Show/`,
      tags: "interest_chomp_show",
   },
   theRestaurantPulse: {
      mt_event: "Restaurant Pulse",
      page_title: "Restaurant Pulse",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/shows/The%20Restaurant%20Pulse/`,
      tags: "interest_pulse",
   },
   restaurantTips: {
      mt_event: "Restaurant Tips",
      page_title: "Restaurant Tips",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/shows/Restaurant%20Tips/`,
      tags: "interest_pulse",
   },

   // ASK ABOUT THIS
   resourcesPage: {
      mt_event: "Resources_Visit",
      page_title: "Resources_Visit",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/resources`,
      tags: "interest_resource",
   },
   resourcesTemplate: {
      mt_event: "Resources_Visit",
      page_title: "Resources_Visit",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/resources/templates`,
      tags: "interest_templates",
   },
   resourcesLibrary: {
      mt_event: "Resources_Visit",
      page_title: "Resources_Visit",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/resources/library`,
      tags: "interest_resource",
   },
   resourcesCalculator: {
      mt_event: "Resources_Visit",
      page_title: "Resources_Visit",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/resources/calculators`,
      tags: "interest_calculator",
   },
   businessGrowth: {
      mt_event: "Business_Growth",
      page_title: "Business_Growth",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/Business_Growth`,
      tags: "Business_Growth",
   },
   emailVerified: {
      mt_event: "Email Verified",
      page_title: "Email Verified",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/email_verified`,
      tags: "email_Verified",
   },
   contactUs: {
      mt_event: "Contact Form",
      page_title: "Contact Form",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/contact`,
      tags: "intent_contact",
   },
   pendingVerification: {
      mt_event: "Pending Verification",
      page_title: "Pending Verification",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/unified/signup`,
      tags: "Pending_Verification",
   },
   downloadTemplate: {
      mt_event: "Template_Download",
      page_title: "Template_Download",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/resources/templates`,
      tags: "downloaded_template",
   },
   downloadLibrary: {
      mt_event: "Library_Download",
      page_title: "Library_Download",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/resources/library`,
      tags: "downloaded_library",
   },
   calculatorInteraction: {
      mt_event: "Calculator_Use",
      page_title: "Calculator_Use",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/resources/calculators`,
      tags: "used_calculator",
   },
   benefitResourceDownload: {
      mt_event: "Benefit_Resource_Download",
      page_title: "Benefit_Resource_Download",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/benefits`,
      tags: "downloaded_benefit_resource",
   },
   masterclassClaimed: {
      mt_event: "Masterclass_Claimed",
      page_title: "Masterclass_Claimed",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/benefits`,
      tags: "claimed_masterclass",
   },
   jobSubscriptionClaimed: {
      mt_event: "Job_Subscription_Claimed",
      page_title: "Job_Subscription_Claimed",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/jobs`,
      tags: "job_subscription_claimed",
   },
   requestedChompShow: {
      mt_event: "requested_chomp_show",
      page_title: "Requested Chomp Show",
      pageurl: `${process.env.NEXT_PUBLIC_BASE_DOMAIN}/benefits/get-featured-on-the-chomp-show-complimentary-restaurant-spotlight/chomp-form`,
      tags: "requested_chomp_show",
   },
} as const satisfies Record<string, MauticCampaignEvent>

export const BUSINESS_GROWTH_TOPIC_SLUGS = new Set(["franchising", "finance", "operations"])

export function getTopicCampaign(slug: string): MauticCampaignEvent | null {
   // if (slug === "marketing") return MAUTIC_CAMPAIGNS.marketingMasterclass
   if (BUSINESS_GROWTH_TOPIC_SLUGS.has(slug)) return MAUTIC_CAMPAIGNS.businessGrowth
   return null
}

export type PageViewParams = {
   mt_event: string
   page_title: string
   tags: (typeof MAUTIC_CAMPAIGNS)[keyof typeof MAUTIC_CAMPAIGNS]["tags"]
   email?: string
   page_url: string
}
